import { filterConvertCandidates } from "@/input/utils/convertCandidates";

import { normalizeSuggestionKeywords } from "./utils/normalizeKeywords";

import type { SingleSuggestion, SuggestionProvider } from "@/components/suggestions/types";
import type { ConvertCandidate } from "@/input/utils/convertCandidates";

function createSuggestion(candidate: ConvertCandidate, priority: number): SingleSuggestion {
  const { unit, display } = candidate;

  return {
    type: "single",
    item: {
      type: "number",
      key: `convert-${display}`,
      displayName: unit.name ?? display,
      symbol: display,
      value: display,
      category: display,
      keywords: normalizeSuggestionKeywords({ keywords: unit.keywords }),
    },
    priority,
    popupGroup: "units",
  };
}

/**
 * Suggests same-dimension conversion targets for the sidebar "Convert to" field.
 * Candidates come from the caller via `providerSearchOptions.convertUnit` because they are
 * scoped to the selected node's unit dimension, not derivable from the document.
 */
export const convertUnitSuggestionsProvider: SuggestionProvider<"convertUnit"> = {
  type: "convertUnit",
  omitByDefault: true,
  search: (str, _doc, _lang, options) => {
    const candidates = options?.candidates ?? [];
    const filtered = filterConvertCandidates(candidates, str);
    return [filtered.map((candidate, i) => createSuggestion(candidate, filtered.length - i))];
  },
};
